export default __webpack_public_path__ + "f0efe5391f78285a9707505026304f2f.svg";